import { combineReducers } from 'redux';

import { sessionReducer } from './session';

export const getRootReducer = () => combineReducers({
  session: sessionReducer,
  migrations: (state = { version: -1 }) => state
});
